<template>
  <!--  首页荣衔进度条组件-->
  <div>
    <p>{{ this.$t('Region') }}</p>
    <div class="whole">
      <!--    营销经理-->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(bigtarget1)"
          :percentage="bigtarget1" />
        <p>4 000 PV</p>
      </div>
      <!--    高级营销经理-->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(bigtarget2)"
          :percentage="bigtarget2" />
        <p>8 000 PV</p>
      </div>
      <!--    资深营销经理-->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(bigtarget3)"
          :percentage="bigtarget3" />
        <p>20 000 PV</p>
      </div>
      <!--    营销总监-->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(bigtarget4)"
          :percentage="bigtarget4" />
        <p>40 000 PV</p>
      </div>
      <!--    高级营销总监-->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(bigtarget5)"
          :percentage="bigtarget5" />
        <p>80 000 PV</p>
      </div>
      <!--    资深营销总监-->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(bigtarget6)"
          :percentage="bigtarget6" />
        <p>160 000 PV</p>
      </div>
    </div>
    <p>{{ $t('residential.quarters') }}</p>
    <div class="whole">
      <!--   营销经理 -->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(smalltarget1)"
          :percentage="smalltarget1" />
        <p>4 000 PV</p>
      </div>
      <!--    高级营销经理-->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(smalltarget2)"
          :percentage="smalltarget2" />
        <p>8 000 PV</p>
      </div>
      <!--   资深营销经理 -->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(smalltarget3)"
          :percentage="smalltarget3" />
        <p>20 000 PV</p>
      </div>
      <!--   营销总监 -->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(smalltarget4)"
          :percentage="smalltarget4" />
        <p>40 000 PV</p>
      </div>
      <!--   高级营销总监 -->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(smalltarget5)"
          :percentage="smalltarget5" />
        <p>80 000 PV</p>
      </div>
      <!--    资深营销总监-->
      <div class="single">
        <el-progress :text-inside="true" :stroke-width="18" :color="getProgressColor(smalltarget6)"
          :percentage="smalltarget6" />
        <p>160 000 PV</p>
      </div>
    </div>
  </div>
</template>

<script>

import { getCardType } from "@/api/rus/api";
import { mapGetters } from "vuex";

export default {
  name: 'HonorProgressBar',
  data() {
    return {
      schedule: 0, // 大区业绩进度条
      schedule1: 0, // 小区业绩进度条
      target: 0, // 进度条目标
      bigtarget1: 0, // 大区各业绩
      bigtarget2: 0, // 大区各业绩
      bigtarget3: 0, // 大区各业绩
      bigtarget4: 0, // 大区各业绩
      bigtarget5: 0, // 大区各业绩
      bigtarget6: 0, // 大区各业绩
      smalltarget1: 0, // 小区各业绩
      smalltarget2: 0, // 小区各业绩
      smalltarget3: 0, // 小区各业绩
      smalltarget4: 0, // 小区各业绩
      smalltarget5: 0, // 小区各业绩
      smalltarget6: 0 // 小区各业绩
    }
  },
  props: {
  },
  computed: {
    ...mapGetters([
      'language',
      'userCode'
    ]),
  },
  created() {
    this.getinformation()
  },
  methods: {
    getinformation() {
      getCardType({ 'memberNo': this.userCode }).then(res => {
        const { netsell, netsellqita } = res.data
        this.bigtarget1 = this.handleNumber(netsell, '1')
        this.bigtarget2 = this.handleNumber(netsell, '2')
        this.bigtarget3 = this.handleNumber(netsell, '3')
        this.bigtarget4 = this.handleNumber(netsell, '4')
        this.bigtarget5 = this.handleNumber(netsell, '5')
        this.bigtarget6 = this.handleNumber(netsell, '6')
        this.smalltarget1 = this.handleNumber(netsellqita, '1')
        this.smalltarget2 = this.handleNumber(netsellqita, '2')
        this.smalltarget3 = this.handleNumber(netsellqita, '3')
        this.smalltarget4 = this.handleNumber(netsellqita, '4')
        this.smalltarget5 = this.handleNumber(netsellqita, '5')
        this.smalltarget6 = this.handleNumber(netsellqita, '6')
      }).catch(() => {
      })
    },
    handleNumber(value, string) {
      if (+value > 0) {
        switch (string) {
          case "1":
            return value / 4000 * 100 > 100 ? 100 : Math.floor(value / 4000 * 100)
          case "2":
            return value / 8000 * 100 > 100 ? 100 : Math.floor(value / 8000 * 100)
          case "3":
            return value / 20000 * 100 > 100 ? 100 : Math.floor(value / 20000 * 100)
          case "4":
            return value / 40000 * 100 > 100 ? 100 : Math.floor(value / 40000 * 100)
          case "5":
            return value / 80000 * 100 > 100 ? 100 : Math.floor(value / 80000 * 100)
          case "6":
            return value / 160000 * 100 > 100 ? 100 : Math.floor(value / 160000 * 100)
        }
      }
    },
    getProgressColor(percentage) {
      // 根据进度设置颜色
      if (percentage < 100) {
        return '#fbf5e4';
      } else {
        return '#67c23a'; // 绿色
      }
    },
  }
}
</script>

<style scoped lang="scss">
.pagination-container {
  background: #fff;
  text-align: right;
}

.pagination-container.hidden {
  display: none;
}

.whole {
  margin: 10px 0;
  position: relative;
  display: flex;
}

.single {
  flex: 1;

  p {
    margin-top: 10px;
  }
}

::v-deep .el-progress-bar__innerText {
  color: #000;
}

.box {
  border: 1px solid #000;
  border-radius: 20px;
  padding: 20px;
  text-align: left;
}
</style>
